import {
  HeaderSkeleton,
  Line,
  SkeletonRegion,
  TableSkeleton,
} from '@ems/ui/patterns/skeleton-blocks'

export function SessionsSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-32" description="w-48" actions={['h-9 w-32']} />
      <TableSkeleton
        card={{ title: 'w-24', description: 'w-96' }}
        columns={[
          { cell: 'text', widths: ['w-64', 'w-56', 'w-72'], primary: true },
          { cell: 'mono', widths: ['w-24', 'w-28'] },
          { cell: 'muted', widths: ['w-24', 'w-16'] },
          { cell: 'muted', widths: ['w-40', 'w-28', 'w-36'] },
          { cell: 'badge', widths: ['w-20', 'w-16'] },
          { cell: 'icon', header: null, align: 'end', shrink: true },
        ]}
      />
    </SkeletonRegion>
  )
}

export function SpeakersSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-32" description="w-48" actions={['h-9 w-32']} />
      <TableSkeleton
        card={{ title: 'w-36', description: 'w-96' }}
        columns={[
          { cell: 'text', widths: ['w-36', 'w-28', 'w-40'], primary: true },
          { cell: 'muted', widths: ['w-48', 'w-40'] },
          { cell: 'muted', widths: ['w-28', 'w-36'] },
          { cell: 'muted', widths: ['w-20', 'w-28'] },
          { cell: 'text', widths: ['w-6'], align: 'end' },
          { cell: 'badge', widths: ['w-20'] },
          { cell: 'icon', header: null, align: 'end', shrink: true },
        ]}
      />
    </SkeletonRegion>
  )
}

export function RoomsSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-24" description="w-40" />
      <TableSkeleton
        columns={[
          { cell: 'mono', widths: ['w-12', 'w-16'] },
          { cell: 'text', widths: ['w-40', 'w-32', 'w-48'], primary: true },
          { cell: 'text', widths: ['w-10'], align: 'end' },
          { cell: 'text', widths: ['w-6'], align: 'end', header: 'w-32' },
        ]}
      />
    </SkeletonRegion>
  )
}

export function MeetingsSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-8">
      <HeaderSkeleton title="w-28" description="w-64" />
      <div className="flex flex-col gap-1 rounded-lg border px-4 py-3">
        <Line width="w-48" />
        <Line width="w-96" />
      </div>
      <TableSkeleton
        rows={4}
        card={{ title: 'w-24', description: 'w-80' }}
        columns={[
          { cell: 'mono', widths: ['w-28', 'w-24'], primary: true },
          { cell: 'text', widths: ['w-32', 'w-40'] },
          { cell: 'muted', widths: ['w-28', 'w-36'] },
          { cell: 'text', widths: ['w-20', 'w-16'] },
          { cell: 'badge', widths: ['w-20'] },
        ]}
      />
      <TableSkeleton
        rows={4}
        card={{ title: 'w-24', description: 'w-80' }}
        columns={[
          { cell: 'text', widths: ['w-36', 'w-28'], primary: true },
          { cell: 'muted', widths: ['w-32', 'w-24'] },
          { cell: 'text', widths: ['w-16', 'w-20'] },
          { cell: 'text', widths: ['w-6'], align: 'end' },
        ]}
      />
    </SkeletonRegion>
  )
}
